import { lazy } from 'react';

export const LazyFixedStaffTools = lazy(() =>
  import('./FixedStaffTools').then((module) => ({
    default: module.FixedStaffTools,
  })),
);
